const initialState = {
  dataUpdateClient: {},
  loadingUpdateClient: false,
  statusUpdateClient: 0,
};

export default initialState;
